import { makeNamespacedComponent } from '@/ui/utils';
import { Container } from './Container';
import { Item } from './Item';

const Grid = makeNamespacedComponent(Container, {
  Item: Item,
});

export { Grid };
